(function () {
  'use strict';

  // ── CONFIG ────────────────────────────────────────────────────
  var CONFIG = {
    maxChars: 10,
    // Shared Worker — same URL used by both single-plate and double-plate
    workerUrl: 'https://icecity-nameplate.icecity-jewelers12.workers.dev'
  };

  var LOADING_MSGS = [
    'Preparing your design\u2026',
    'Rendering your name\u2026',
    'Applying flat emerald finish\u2026',
    'Almost ready\u2026'
  ];

  // ── FONTS (5 total — matches the double-plate customizer's font set) ──
  var FONTS = [
    { id: 'alex-brush',   name: 'Alex Brush',          family: "'Alex Brush', cursive",          style: 'bold brush' },
    { id: 'great-vibes',  name: 'Great Vibes',         family: "'Great Vibes', cursive",         style: 'flowing elegant' },
    { id: 'parisienne',   name: 'Parisienne',          family: "'Parisienne', cursive",          style: 'ornate classic' },
    { id: 'allura',       name: 'Allura',              family: "'Allura', cursive",              style: 'delicate refined' },
    { id: 'petit-formal', name: 'Petit Formal Script', family: "'Petit Formal Script', cursive", style: 'formal elegant' }
  ];

  // Rich, calligraphy-specific descriptions for the Ideogram prompt.
  // Ideogram has no knowledge of the font names themselves — it can only
  // render what it can "see" described in words. Each entry calls out
  // stroke-weight contrast, loop/flourish behavior, slant angle, how
  // letters connect, and overall character, since these are the concrete
  // visual cues that actually steer image generation, unlike generic
  // one-line descriptions like "elegant flowing script."
  var FONT_PROMPT_STYLES = {
    'alex-brush':
      'a bold brush-calligraphy cursive script with strong contrast between thick downstrokes and thin upstrokes, as if painted with a wide flat brush; letters lean forward at a steep slant and connect in continuous flowing loops with minimal lifting, giving it an energetic, confident, hand-painted signature quality',
    'great-vibes':
      'an elegant, high-contrast flowing cursive script with long delicate connecting strokes between letters; tall looping ascenders and descenders extend gracefully above and below the main letter body, with a light, airy, romantic quality reminiscent of formal wedding calligraphy',
    'parisienne':
      'an ornate, classic cursive script with decorative curling flourishes at the start and end of words; letters have rounded, bubbly forms with moderate stroke-width contrast, tightly spaced loops, and a vintage French-postcard character',
    'allura':
      'a delicate, refined cursive script with thin, slender, uniform strokes and minimal contrast between thick and thin; letters are gracefully looped but restrained rather than ornate, with a light forward slant and an airy, understated elegance',
    'petit-formal':
      'a formal, controlled calligraphic cursive script with even, moderate stroke weight and tight, precise closed loops; letters sit nearly upright with only a slight slant, joined smoothly with minimal flourish, giving it a polished, formal invitation-style quality'
  };

  // ── HOLDERS ───────────────────────────────────────────────────
  var HOLDERS = [
    { id: 'default',     name: 'Default',           icon: '\u25CB',       promptDesc: 'a simple rounded loop bail at the top-center for a chain to pass through' },
    { id: 'heart',       name: 'Heart',             icon: '\u2764\uFE0F', promptDesc: 'a puffed 3D heart bail charm' },
    { id: 'butterfly',   name: 'Butterfly',         icon: '\uD83E\uDD8B', promptDesc: 'a symmetrical butterfly charm with open wings' },
    { id: 'moneybag',    name: 'Money Bag',         icon: '\uD83D\uDCB0', promptDesc: 'a cinched money bag charm with a dollar sign engraved on the front' },
    { id: 'stethoscope', name: 'Stethoscope Heart', icon: '\uD83E\uDE7A', promptDesc: 'a medical stethoscope twisted into a heart shape charm' },
    { id: 'barbie',      name: 'Barbie Head',       icon: '\uD83D\uDC69', promptDesc: 'a side-profile silhouette of a classic woman head with a high ponytail' },
    { id: 'crown',       name: 'Crown',             icon: '\uD83D\uDC51', promptDesc: 'a 5-point royal crown charm with small spheres on the tips' },
    { id: 'star',        name: 'Star',              icon: '\u2B50',       promptDesc: 'a sharp symmetrical 5-point star charm' },
    { id: 'flower',      name: 'Four-Leaf Clover',  icon: '\uD83C\uDF40', promptDesc: 'a detailed four-leaf clover charm with raised center vein and rounded petals' },
    { id: 'diamond',     name: 'Diamond',           icon: '\uD83D\uDC8E', promptDesc: 'a brilliant-cut multi-faceted diamond gemstone charm' },
    { id: 'goat',        name: 'Goat',              icon: '\uD83D\uDC10', promptDesc: 'a stylized goat head silhouette charm' },
    { id: 'hellokitty',  name: 'Hello Kitty',       icon: '\uD83D\uDC31', promptDesc: 'a cute cartoon cat head charm with a distinct bow on the left ear' },
    { id: 'key',         name: 'Key',               icon: '\uD83D\uDD11', promptDesc: 'a vintage skeleton key charm' },
    { id: 'lock',        name: 'Lock',              icon: '\uD83D\uDD12', promptDesc: 'a classic square padlock charm' }
  ];

  // ── STATE ─────────────────────────────────────────────────────
  var state = {
    name: '', font: FONTS[0], holder: HOLDERS[0],
    previewDataUrl: null,
    isGenerating: false, isAdding: false
  };

  var dom = {};
  var loaderTimer = null;
  var loaderMsgIdx = 0;

  // ── INIT ──────────────────────────────────────────────────────
  function init() {
    dom.overlay           = document.getElementById('np-overlay');
    dom.nameInput         = document.getElementById('np-name-input');
    dom.charCount         = document.getElementById('np-char-count');
    dom.fontPicker        = document.getElementById('np-font-picker');
    dom.fontTrigger       = document.getElementById('np-font-trigger');
    dom.fontTriggerPrev   = document.getElementById('np-font-trigger-preview');
    dom.fontDropdown      = document.getElementById('np-font-dropdown');
    dom.holderPicker      = document.getElementById('np-holder-picker');
    dom.holderTrigger     = document.getElementById('np-holder-trigger');
    dom.holderTriggerIcon = document.getElementById('np-holder-trigger-icon');
    dom.holderTriggerName = document.getElementById('np-holder-trigger-name');
    dom.holderDropdown    = document.getElementById('np-holder-dropdown');
    dom.generateBtn       = document.getElementById('np-generate-btn');
    dom.generateLabel     = document.getElementById('np-generate-label');
    dom.previewEmpty      = document.getElementById('np-preview-empty');
    dom.aiLoader          = document.getElementById('np-ai-loader');
    dom.loaderText        = document.getElementById('np-loader-text');
    dom.aiImage           = document.getElementById('np-ai-image');
    dom.addBtn            = document.getElementById('np-add-btn');
    dom.errorMsg          = document.getElementById('np-error');

    dom.regenerateBtn = { style: {}, addEventListener: function () {} };
    dom.previewHint   = { style: {}, innerHTML: '' };

    if (!dom.overlay) return;

    buildFontPicker();
    buildHolderPicker();
    addFontDisclaimer();
    bindEvents();
  }

  // ── FONT DISCLAIMER ───────────────────────────────────────────
  // Sets honest expectations: the picker shows the FONT STYLE, but the
  // actual pendant is AI-rendered per order, so exact pixel-for-pixel
  // match to the picker preview isn't guaranteed. Injected via JS so no
  // template/HTML file edit is needed.
  function addFontDisclaimer() {
    if (!dom.fontPicker || dom.fontPicker.parentNode.querySelector('.np-font-disclaimer')) return;
    var note = document.createElement('p');
    note.className = 'np-font-disclaimer';
    note.textContent = 'Preview shows font style — your piece is individually AI-rendered for a one-of-a-kind emerald finish.';
    note.style.cssText = 'font-size:12px;color:#8a8a8a;margin-top:8px;line-height:1.4;';
    dom.fontPicker.parentNode.insertBefore(note, dom.fontPicker.nextSibling);
  }

  // ── FONT PICKER ───────────────────────────────────────────────
  function buildFontPicker() {
    dom.fontTriggerPrev.style.fontFamily = state.font.family;
    dom.fontDropdown.innerHTML = '';
    FONTS.forEach(function (f, i) {
      var opt = document.createElement('div');
      opt.className = 'np-font-option' + (i === 0 ? ' is-selected' : '');
      opt.dataset.fontId = f.id;
      opt.innerHTML =
        '<span class="np-font-option__preview" style="font-family:' + f.family + '">' +
          (state.name.trim() || 'Shanelle') + '</span>' +
        '<span class="np-font-option__name">' + f.name + ' \u00b7 ' + f.style + '</span>';
      opt.addEventListener('click', function () { selectFont(f); closeFontDropdown(); });
      dom.fontDropdown.appendChild(opt);
    });
  }

  function selectFont(font) {
    state.font = font; state.previewDataUrl = null;
    dom.fontTriggerPrev.textContent = state.name.trim() || 'Shanelle';
    dom.fontTriggerPrev.style.fontFamily = font.family;
    dom.fontDropdown.querySelectorAll('.np-font-option').forEach(function (el) {
      el.classList.toggle('is-selected', el.dataset.fontId === font.id);
    });
    resetPreview();
  }

  function openFontDropdown() {
    var sample = state.name.trim() || 'Shanelle';
    dom.fontDropdown.querySelectorAll('.np-font-option__preview').forEach(function (el) {
      el.textContent = sample;
    });
    closeHolderDropdown();
    dom.fontDropdown.classList.add('is-open');
    dom.fontTrigger.classList.add('is-open');
  }
  function closeFontDropdown() {
    dom.fontDropdown.classList.remove('is-open');
    dom.fontTrigger.classList.remove('is-open');
  }
  function toggleFontDropdown() {
    dom.fontDropdown.classList.contains('is-open') ? closeFontDropdown() : openFontDropdown();
  }

  // ── HOLDER PICKER ─────────────────────────────────────────────
  function buildHolderPicker() {
    dom.holderDropdown.innerHTML = '';
    HOLDERS.forEach(function (h, i) {
      var opt = document.createElement('div');
      opt.className = 'np-holder-option' + (i === 0 ? ' is-selected' : '');
      opt.dataset.holderId = h.id;
      opt.innerHTML =
        '<span class="np-holder-option__icon">' + h.icon + '</span>' +
        '<span class="np-holder-option__name">' + h.name + '</span>';
      opt.addEventListener('click', function () { selectHolder(h); closeHolderDropdown(); });
      dom.holderDropdown.appendChild(opt);
    });
  }

  function selectHolder(holder) {
    state.holder = holder; state.previewDataUrl = null;
    dom.holderTriggerIcon.textContent = holder.icon;
    dom.holderTriggerName.textContent = holder.name;
    dom.holderDropdown.querySelectorAll('.np-holder-option').forEach(function (el) {
      el.classList.toggle('is-selected', el.dataset.holderId === holder.id);
    });
    resetPreview();
  }

  function openHolderDropdown() {
    closeFontDropdown();
    dom.holderDropdown.classList.add('is-open');
    dom.holderTrigger.classList.add('is-open');
  }
  function closeHolderDropdown() {
    dom.holderDropdown.classList.remove('is-open');
    dom.holderTrigger.classList.remove('is-open');
  }
  function toggleHolderDropdown() {
    dom.holderDropdown.classList.contains('is-open') ? closeHolderDropdown() : openHolderDropdown();
  }

  // ── EVENTS ────────────────────────────────────────────────────
  function bindEvents() {
    document.querySelectorAll('[data-np-trigger]').forEach(function (b) {
      b.addEventListener('click', openModal);
    });
    document.getElementById('np-close-btn').addEventListener('click', closeModal);
    dom.overlay.addEventListener('click', function (e) {
      if (e.target === dom.overlay) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (dom.fontDropdown.classList.contains('is-open')) closeFontDropdown();
        else if (dom.holderDropdown.classList.contains('is-open')) closeHolderDropdown();
        else closeModal();
      }
    });
    document.addEventListener('click', function (e) {
      if (dom.fontPicker && !dom.fontPicker.contains(e.target)) closeFontDropdown();
      if (dom.holderPicker && !dom.holderPicker.contains(e.target)) closeHolderDropdown();
    });
    dom.fontTrigger.addEventListener('click', function (e) { e.stopPropagation(); toggleFontDropdown(); });
    dom.holderTrigger.addEventListener('click', function (e) { e.stopPropagation(); toggleHolderDropdown(); });

    dom.nameInput.addEventListener('input', function () {
      var v = dom.nameInput.value.slice(0, CONFIG.maxChars);
      dom.nameInput.value = v; state.name = v; state.previewDataUrl = null;
      dom.charCount.textContent = v.length + ' / ' + CONFIG.maxChars + ' characters';
      dom.fontTriggerPrev.textContent = v || 'Shanelle';
      clearError();
      checkGenerateBtn();
      resetPreview();
    });

    dom.generateBtn.addEventListener('click', generatePreview);
    dom.addBtn.addEventListener('click', handleAddToCart);
  }

  // ── MODAL ─────────────────────────────────────────────────────
  function openModal() {
    dom.overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { dom.nameInput.focus(); }, 80);
  }
  function closeModal() {
    dom.overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    closeFontDropdown(); closeHolderDropdown();
  }

  function resetPreview() {
    dom.aiImage.style.display = 'none';
    dom.aiImage.src = '';
    dom.previewEmpty.style.display = 'flex';
    dom.addBtn.disabled = true;
    state.previewDataUrl = null;
  }

  function checkGenerateBtn() {
    dom.generateBtn.disabled = !state.name.trim() || state.isGenerating;
  }

  // ── GENERATE PREVIEW — calls the shared Worker with plateType: 'single' ──
  function generatePreview() {
    if (!state.name.trim() || state.isGenerating) return;

    state.isGenerating = true;
    state.previewDataUrl = null;

    dom.previewEmpty.style.display = 'none';
    dom.aiImage.style.display = 'none';
    dom.aiImage.src = '';
    dom.aiLoader.style.display = 'flex';
    dom.generateBtn.disabled = true;
    dom.generateLabel.textContent = 'Generating\u2026';
    dom.addBtn.disabled = true;
    clearError();

    loaderMsgIdx = 0;
    dom.loaderText.textContent = LOADING_MSGS[0];
    clearInterval(loaderTimer);
    loaderTimer = setInterval(function () {
      loaderMsgIdx = (loaderMsgIdx + 1) % LOADING_MSGS.length;
      dom.loaderText.textContent = LOADING_MSGS[loaderMsgIdx];
    }, 2500);

    fetch(CONFIG.workerUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        plateType: 'single',
        name: state.name,
        font: state.font.name,
        fontDesc: FONT_PROMPT_STYLES[state.font.id] || state.font.style,
        holder: state.holder.name,
        holderDesc: state.holder.promptDesc
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Worker error ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var partsArr = data && data.candidates && data.candidates[0] &&
                       data.candidates[0].content && data.candidates[0].content.parts;
        var b64 = null;
        if (partsArr) {
          for (var i = 0; i < partsArr.length; i++) {
            var d = partsArr[i].inlineData || partsArr[i].inline_data;
            if (d && d.data) { b64 = d.data; break; }
          }
        }
        if (!b64) throw new Error('No image returned');

        var dataUrl = 'data:image/png;base64,' + b64;
        clearInterval(loaderTimer);
        state.isGenerating = false;
        state.previewDataUrl = dataUrl;

        dom.aiLoader.style.display = 'none';
        dom.aiImage.src = dataUrl;
        dom.aiImage.style.display = 'block';
        dom.generateBtn.disabled = false;
        dom.generateLabel.textContent = 'Generate Preview';
        dom.addBtn.disabled = false;
      })
      .catch(function (err) {
        clearInterval(loaderTimer);
        state.isGenerating = false;
        dom.aiLoader.style.display = 'none';
        dom.previewEmpty.style.display = 'flex';
        showError('Generation failed. Please try again.');
        dom.generateBtn.disabled = false;
        dom.generateLabel.textContent = 'Generate Preview';
        console.error('Generation error:', err);
      });
  }

  // ── CLOUDINARY UPLOAD (uploads the FINAL generated image for the cart) ──
  function uploadPreview() {
    return new Promise(function (resolve) {
      if (!state.previewDataUrl) {
        resolve(null);
        return;
      }
      var fd = new FormData();
      fd.append('file', state.previewDataUrl);
      fd.append('upload_preset', 'namelpate_preview');
      fd.append('folder', 'nameplate-previews/single');
      fetch('https://api.cloudinary.com/v1_1/dbej1s1ia/image/upload',
        { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function (d) { resolve(d.secure_url || null); })
        .catch(function () { resolve(null); });
    });
  }

  // ── ADD TO CART ───────────────────────────────────────────────
  function handleAddToCart() {
    clearError();
    if (!state.name.trim()) {
      showError('Please enter a name for your nameplate.');
      dom.nameInput.focus(); return;
    }
    var variantId = getVariantId();
    if (!variantId) {
      showError('Could not find the product. Please visit the product page.');
      return;
    }
    setLoading(true);
    uploadPreview().then(function (imageUrl) {
      var props = {
        'Plate Type':     'Single Plate',
        'Nameplate Text': state.name,
        'Font Style':     state.font.name,
        'Holder Charm':   state.holder.name
      };
      if (imageUrl) props['Preview Image'] = imageUrl;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: props }] })
      });
    })
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function () {
      setLoading(false);
      closeModal();
      if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
      else window.location.href = '/cart';
    })
    .catch(function () {
      setLoading(false);
      showError('Something went wrong. Please try again.');
    });
  }

  function getVariantId() {
    var sel = document.querySelector('select[name="id"], input[name="id"]:checked, input[name="id"]');
    if (sel && sel.value) return parseInt(sel.value, 10);
    if (window.__NAMEPLATE_VARIANT_ID__) return parseInt(window.__NAMEPLATE_VARIANT_ID__, 10);
    return null;
  }

  function setLoading(b) {
    state.isAdding = b;
    dom.addBtn.disabled = b;
    dom.addBtn.classList.toggle('is-loading', b);
  }
  function showError(msg) { dom.errorMsg.textContent = msg; dom.errorMsg.classList.add('is-visible'); }
  function clearError()   { dom.errorMsg.classList.remove('is-visible'); }

  document.addEventListener('DOMContentLoaded', init);

})();